import Page from 'front/pages/Page/Page';
import * as _ from 'underscore';

import TopBar from 'front/components/Common/TopBar/TopBar';

import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

import {VIEWPORT_EVENTS, WINDOW_BREAKPOINT} from '../../constants/Constants';
import './Illustration.less';
import * as Template from './Illustration.jinja';

const Selectors = {
    el: '.Illustration',
    sliderContainerJobs: '.swiper-container.jobs',
    sliderNextJobs: '.swiper-button-next.jobs',
    sliderPrevJobs: '.swiper-button-prev.jobs',
    sliderContainerSuggestion: '.swiper-container.suggestion',
    sliderNextSuggestion: '.swiper-button-next.suggestion',
    sliderPrevSuggestion: '.swiper-button-prev.suggestion'
};

const BindFunctions = [
    'onResize',
    'initSlider',
    'onNext',
    'onPrev'
];

export default class Post extends Page {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.sliderNext}`]: this.onNext,
            [`${VIEWPORT_EVENTS.click} ${Selectors.sliderPrev}`]: this.onPrev
        };
    }

    constructor(options = {}) {
        options.el = '.Illustration';
        options.VIEWS_TO_REGISTER = {
            'top-bar': {selector: '.TopBar', viewConstructor: TopBar}
        };
        options.template = Template;
        super(options);
        _.bindAll(this, BindFunctions);

        this.onResize();
        $(window).on(VIEWPORT_EVENTS.resize, this.onResize);
    }

    onResize() {
        let ww = window.innerWidth;
        if (WINDOW_BREAKPOINT.widthBreakpoint >= ww) {
            this.swiper.destroy(true, true, true);
        } else {
            this.initSlider();
        }
    }

    initSlider() {
        this.swiper = new Swiper(Selectors.sliderContainerJobs, {
            breakpoints: {
                768: {
                    slidesPerView: 8,
                    slidesPerGroup: 4,
                    resizeReInit: true,
                    spaceBetween: 20,
                    hashNavigation: {
                        watchState: true
                    },
                    navigation: {
                        nextEl: Selectors.sliderNextJobs,
                        prevEl: Selectors.sliderPrevJobs
                    }
                }
            }
        });

        this.swiper = new Swiper(Selectors.sliderContainerSuggestion, {
            breakpoints: {
                768: {
                    slidesPerView: 8,
                    slidesPerGroup: 4,
                    resizeReInit: true,
                    spaceBetween: 20,
                    hashNavigation: {
                        watchState: true
                    },
                    navigation: {
                        nextEl: Selectors.sliderNextSuggestion,
                        prevEl: Selectors.sliderPrevSuggestion
                    }
                }
            }
        });
    }

    onNext() {
        this.observer.observe();
    }

    onPrev() {
        this.observer.observe();
    }
}
